import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import BackToTop from "@/components/BackToTop";
import api from "@/lib/api";

export default function Layout({ children }) {
  useEffect(() => {
    let sid = sessionStorage.getItem("hhw_sid");
    if (!sid) { sid = Math.random().toString(36).slice(2) + Date.now(); sessionStorage.setItem("hhw_sid", sid); }
    if (!sessionStorage.getItem("hhw_tracked")) {
      api.post("/track", { session_id: sid }).then(() => sessionStorage.setItem("hhw_tracked", "1")).catch(() => {});
    }
  }, []);

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1 pt-[68px] md:pt-[76px]">{children}</main>
      <Footer />
      <WhatsAppButton />
      <BackToTop />
    </div>
  );
}
